import { useEffect, useState } from 'react';
import api from '@/lib/api';

/**
 * Loads GET /api/page/reviews. Falls back gracefully on error.
 */
export function useReviewsData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .get('/page/reviews')
      .then((res) => { if (!cancelled) setData(res.data?.data || null); })
      .catch(() => { if (!cancelled) setData(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { data, loading };
}
